import memoize from 'memoize-one';

import { CUSTOM_AMOUNT_VALIDATION_STATUS } from '../../Utils/customAmountValidationStatus';
import { PaymentScreenTypes, PaymentTypes } from '../../Utils/PaymentTypes';

import { Dimensions, Platform } from 'react-native'

const {
  DEFAULT,
  SUCCESSOFFERGIFT,
  ADDDATAOFFER,
  UPGRADETOOFFER,
  PAYMENTSUCCESSFULLY,
  PAYMENTFAILD,
  DATAADDED,
  OFFERGIFT,
  SETUP_AUTO_BILL,
  SETUP_AUTO_BILL_SUCCESS,
  SETUP_AUTO_BILL_ERROR,
  SETUP_AUTO_TOP_UP,
  SETUP_AUTO_TOP_UP_SUCCESS,
  SETUP_AUTO_TOP_UP_ERROR,
  TOP_UP_SOMEONE_ELSE,
  TOP_UP_SOMEONE_ELSE_SUCCESS,
  TOP_UP_SOMEONE_ELSE_ERROR,
  CUSTOM_AMOUNT,
  VOUCHER_INTIIAL_STATE,
  VOUCHER_TOP_UP_SUCCESS,
  VOUCHER_TOP_UP_ERROR,
  VOUCHER_SCAN_QR_STATE,
} = PaymentScreenTypes;

const getPaymentMethodConfig = (
  onAddCard,
  defaultPayment,
  onSelectDefaultCard,
  onOpenCardList,
  isCardListOpend,
  renderExtraCard,
  paymentMethodAccessibilityLabel,
  paymentEditIconAccessibilityLabel,
  paymentVisaInfoAccessibilityLabel,
  isPaymentMethod,
) => {
  return {
    isPaymentMethod,
    onAddCard,
    defaultPayment,
    onSelectDefaultCard,
    onOpenCardList,
    isCardListOpend,
    renderExtraCard,
    paymentMethodAccessibilityLabel,
    paymentEditIconAccessibilityLabel,
    paymentVisaInfoAccessibilityLabel,
  };
};

const getButtonConfig = (
  type,
  title,
  onPress,
  ID,
  placeHolders,
  disabled,
  successBtnDisabledStyle,
) => {
  return {
    [`btn${type}Title`]: title,
    [`on${type}BtnPress`]: onPress,
    [`${type.toLowerCase()}BtnID`]: ID,
    [`btn${type}PlaceHolders`]: placeHolders,
    [`isBtn${type}Disabled`]: disabled,
    [`${type}BtnDisabledStyle`]: successBtnDisabledStyle,
  };
};

const getPaymentFooterConfig = props => {
  const {
    checkObjectHasProperty,
    onConfirmPayment,
    onPressPaymentCancel,
    onDiscardGift,
    onCompletePurchaseOfferPress,
    onClosePayment,
    onUpgradePayment,
    onRejectUpgradePayment,
    onBuyOffer,
    selectedValue,
    defaultPayment,
    onAddCard,
    onOpenCardList,
    isCardListOpend,
    onSelectDefaultCard,
    renderExtraCard,
    offerValues,
    defaultWheelValue,
    paymentMethodAccessibilityLabel,
    paymentEditIconAccessibilityLabel,
    paymentVisaInfoAccessibilityLabel,
    paymentDefaultOKBtnID,
    TPpaymentRetryAgainBtn,
    TPpaymentCancelBtn,
    offerGiftOKBtnID,
    offerGiftCloseBtnID,
    upgradeOfferOKBtnID,
    upgradeOfferCloseBtnID,
    paymentSuccessfullyCloseBtnID,
    addedDataOKBtnID,
    addedDataCloseBtnID,
    type,
    onTopUpRecipientNumberSubmit,
    isValidTopupNumber,
    onAutoTopUpNext,
    autoTopUpData,
    onBackFromOffer,
    onAutoTopUpErrorReturn,
    customAmountValidation,
    isPaymentMethod,
    onConfirmCode,
    confirmCodeBtnID,
    onCancelQRCodeScan,
    cancelQRScan,
    voucherTopupQrScannerFooterBtnContainerStyle,
    voucherTopupQrScannerFooterBtnStyle,
    voucherTopupQrScannerBtnType,
    isValidVoucherTopupNumber,
    voucherBtnContainerStyle,
    successBtnDisabledStyle,
    successBtnDisabledTextStyle,
    closeModal,
    closeBtnID,
    btnSuccessStyle,
    onRetryAgainPress,
    reTryAgainBtnID,
    isTwoBtnVoucherError,
    isTopupSomeOneElseErrorSingleAction,
    topupSomeOneElseErrorSingleActionStyle,
    topupSomeoneElseErrorBackBtnID,
  } = props;

  const isBillingPayment = type === PaymentTypes.BILLING_PAYMENT;
  const isBalanceTopUp = type === PaymentTypes.BALANCE_TOP_UP;
  const isVoucherTopUp = type === PaymentTypes.VOUCHER_TOP_UP;

  const topUpFooter = Platform.OS === 'web' && Dimensions.get('window').width > 700 ? {
    isPaymentMethod: true,
    ...getButtonConfig(
      'Success',
      'top_up_someone_else_next_button_title',
      onConfirmPayment,
      paymentSuccessfullyCloseBtnID,
      paymentDefaultOKBtnID,
      defaultPayment
    ),
    ...getPaymentMethodConfig(
      onAddCard,
      defaultPayment,
      onSelectDefaultCard,
      onOpenCardList,
      isCardListOpend,
      renderExtraCard,
      paymentMethodAccessibilityLabel,
      paymentEditIconAccessibilityLabel,
      paymentVisaInfoAccessibilityLabel
    ),
    isBtnSuccessDisabled: !isValidTopupNumber,
    onOpenCardList,
    isValidTopupNumber: isValidTopupNumber
  } : {
    isPaymentMethod: false,
    ...getButtonConfig(
      'Success',
      'top_up_someone_else_next_button_title',
      onTopUpRecipientNumberSubmit,
      paymentSuccessfullyCloseBtnID,
      paymentDefaultOKBtnID
    ),
    isBtnSuccessDisabled: !isValidTopupNumber
  }


  return {
    [DEFAULT]: {
      hasMoreBtns: isBillingPayment,
      ...getButtonConfig(
        'Success',
        type === PaymentTypes.SETUP_AUTO_TOP_UP
          ? 'auto_top_up_quick_action_button_text'
          : type === PaymentTypes.EDIT_AUTO_TOP_UP
            ? 'auto_top_up_quick_action_edit_button_text'
            : isBillingPayment
              ? 'payment_quick_action_confirm_button_text'
              : 'dashboard_upgrade_component_button_topup',
        onConfirmPayment,
        paymentDefaultOKBtnID,
      ),
      ...getButtonConfig(
        'Reject',
        isBillingPayment ? 'payment_quick_action_reject_button_text' : null,
        onPressPaymentCancel,
      ),
      ...getPaymentMethodConfig(
        onAddCard,
        defaultPayment,
        onSelectDefaultCard,
        onOpenCardList,
        isCardListOpend,
        renderExtraCard,
        paymentMethodAccessibilityLabel,
        paymentEditIconAccessibilityLabel,
        paymentVisaInfoAccessibilityLabel,
        isPaymentMethod,
      ),
      isValidTopupNumber: true
    },
    [SETUP_AUTO_BILL]: {
      hasMoreBtns: true,
      ...getButtonConfig(
        'Success',
        'auto_bill_quick_action_primary_button_text',
        onConfirmPayment,
        paymentDefaultOKBtnID,
      ),
      ...getButtonConfig(
        'Reject',
        'auto_bill_quick_action_secondary_button_text',
        onPressPaymentCancel,
        TPpaymentCancelBtn,
      ),
      ...getPaymentMethodConfig(
        onAddCard,
        defaultPayment,
        onSelectDefaultCard,
        onOpenCardList,
        isCardListOpend,
        renderExtraCard,
        paymentMethodAccessibilityLabel,
        paymentEditIconAccessibilityLabel,
        paymentVisaInfoAccessibilityLabel,
        isPaymentMethod,
      ),
    },
    [SETUP_AUTO_BILL_SUCCESS]: {
      ...getButtonConfig(
        'Success',
        'auto_bill_quick_action_successful_primary_button_text',
        onClosePayment,
        paymentSuccessfullyCloseBtnID,
      ),
    },
    [SETUP_AUTO_BILL_ERROR]: {
      ...getButtonConfig('Success', 'auto_bill_quick_action_failure_try_again', onConfirmPayment),
    },
    [SETUP_AUTO_TOP_UP]: {
      isPaymentMethod: false,
      hasMoreBtns: true,
      ...getButtonConfig('Success', 'auto_top_up_quick_action_next_button', onAutoTopUpNext),
      ...getButtonConfig('Reject', 'auto_top_up_quick_action_cancel_button', onClosePayment),
      isBtnSuccessDisabled:
        !autoTopUpData ||
        !autoTopUpData.occurrence ||
        (!autoTopUpData.selectedIndex && autoTopUpData.selectedIndex !== 0),
    },
    [SETUP_AUTO_TOP_UP_SUCCESS]: {
      isPaymentMethod: false,
      ...getButtonConfig(
        'Success',
        'auto_top_up_quick_action_success_primary_button_text',
        onClosePayment,
      ),
    },
    [SETUP_AUTO_TOP_UP_ERROR]: {
      hasMoreBtns: true,
      ...getButtonConfig(
        'Success',
        'auto_top_up_quick_action_failure_primary_button_text',
        onConfirmPayment,
      ),
      ...getButtonConfig(
        'Reject',
        'auto_top_up_quick_action_failure_secondary_button_text',
        onAutoTopUpErrorReturn,
      ),
    },
    [TOP_UP_SOMEONE_ELSE]: topUpFooter,
    [TOP_UP_SOMEONE_ELSE_SUCCESS]: {
      ...getButtonConfig(
        'Success',
        'top_up_someone_else_successful_primary_button_text',
        onClosePayment,
        paymentSuccessfullyCloseBtnID,
      ),
      ...getPaymentMethodConfig(
        onAddCard,
        defaultPayment,
        onSelectDefaultCard,
        onOpenCardList,
        isCardListOpend,
        renderExtraCard,
        paymentMethodAccessibilityLabel,
        paymentEditIconAccessibilityLabel,
        paymentVisaInfoAccessibilityLabel
      ),
    },
    [TOP_UP_SOMEONE_ELSE_ERROR]: {
      hasMoreBtns: !isTopupSomeOneElseErrorSingleAction,
      ...getButtonConfig(
        isTopupSomeOneElseErrorSingleAction ? 'Reject' : 'Success',
        'top_up_someone_else_quick_action_failure_primary_button_text',
        onConfirmPayment,
        reTryAgainBtnID,
      ),
      ...getButtonConfig(
        !isTopupSomeOneElseErrorSingleAction ? 'Reject' : 'Success',
        'top_up_someone_else_quick_action_failure_secondary_button_text',
        onClosePayment,
        topupSomeoneElseErrorBackBtnID,
      ),
      btnSuccessType: !isTopupSomeOneElseErrorSingleAction ? 'primary' : 'secondary',
      btnRejectType: isTopupSomeOneElseErrorSingleAction ? 'primary' : 'secondary',
      btnSuccessStyle: !isTopupSomeOneElseErrorSingleAction
        ? null
        : topupSomeOneElseErrorSingleActionStyle,
    },
    [OFFERGIFT]: {
      hasMoreBtns: true,
      ...getButtonConfig(
        'Success',
        'Complete purchase',
        onCompletePurchaseOfferPress,
        offerGiftOKBtnID,
      ),
      ...getButtonConfig('Reject', 'Back', onBackFromOffer, offerGiftCloseBtnID),
    },

    [SUCCESSOFFERGIFT]: {
      ...getButtonConfig(
        'Success',
        'top_up_quick_action_return_to_dashboard_button_text',
        onClosePayment,
        paymentSuccessfullyCloseBtnID,
      ),
    },

    [ADDDATAOFFER]: {
      hasMoreBtns: true,
      upgradingPayment: true,
      ...getButtonConfig(
        'Success',
        'add_data_buy_offer_confirm_with_payment',
        onBuyOffer,
        addedDataOKBtnID,
        [
          defaultWheelValue && defaultWheelValue.length > 0 && defaultWheelValue[0].value,
          checkObjectHasProperty(offerValues, 'currency'),
        ],
      ),
      ...getButtonConfig(
        'Reject',
        'add_data_buy_offer_discard_with_payment',
        onDiscardGift,
        addedDataCloseBtnID,
        [selectedValue && selectedValue.value, checkObjectHasProperty(offerValues, 'currency')],
      ),
      ...getPaymentMethodConfig(
        onAddCard,
        defaultPayment,
        onSelectDefaultCard,
        onOpenCardList,
        isCardListOpend,
        renderExtraCard,
        paymentMethodAccessibilityLabel,
        paymentEditIconAccessibilityLabel,
        paymentVisaInfoAccessibilityLabel,
        isPaymentMethod,
      ),
    },
    [UPGRADETOOFFER]: {
      hasMoreBtns: true,
      upgradingPayment: true,
      ...getButtonConfig(
        'Success',
        'top_up_quick_action_offer_button',
        onUpgradePayment,
        upgradeOfferOKBtnID,
        [
          defaultWheelValue && defaultWheelValue.length > 0 && defaultWheelValue[0].value,
          checkObjectHasProperty(offerValues, 'currency'),
        ],
      ),
      ...getButtonConfig(
        'Reject',
        'top_up_quick_action_no_offer_button',
        onRejectUpgradePayment,
        upgradeOfferCloseBtnID,
        [selectedValue && selectedValue.value, checkObjectHasProperty(offerValues, 'currency')],
      ),
    },
    [PAYMENTSUCCESSFULLY]: {
      ...getButtonConfig(
        'Success',
        isBillingPayment || isBalanceTopUp
          ? 'payment_quick_action_title_done_button_text'
          : 'top_up_quick_action_return_to_dashboard_button_text',
        onClosePayment,
        paymentSuccessfullyCloseBtnID,
      ),
    },
    [PAYMENTFAILD]: {
      hasMoreBtns: true,
      ...getButtonConfig('Success', 'pay_bill_quick_action_failure_try_again', onConfirmPayment),
      ...getButtonConfig(
        'Reject',
        'pay_bill_quick_action_failure_cancel',
        onClosePayment,
        TPpaymentRetryAgainBtn,
      ),
    },
    [DATAADDED]: {
      ...getButtonConfig(
        'Success',
        'top_up_quick_action_return_to_dashboard_button_text',
        onClosePayment,
        paymentSuccessfullyCloseBtnID,
      ),
    },
    [CUSTOM_AMOUNT]: {
      ...getButtonConfig(
        'Success',
        type === PaymentTypes.SETUP_AUTO_TOP_UP
          ? 'auto_top_up_quick_action_button_text'
          : type === PaymentTypes.EDIT_AUTO_TOP_UP
            ? 'auto_top_up_quick_action_edit_button_text'
            : isBillingPayment
              ? 'payment_quick_action_confirm_button_text'
              : 'dashboard_upgrade_component_button_topup',
        onConfirmPayment,
        paymentDefaultOKBtnID,
        '',
        customAmountValidation !== CUSTOM_AMOUNT_VALIDATION_STATUS.VALID,
      ),
      ...getPaymentMethodConfig(
        onAddCard,
        defaultPayment,
        onSelectDefaultCard,
        onOpenCardList,
        isCardListOpend,
        renderExtraCard,
        paymentMethodAccessibilityLabel,
        paymentEditIconAccessibilityLabel,
        paymentVisaInfoAccessibilityLabel,
        isPaymentMethod,
      ),
    },
    [VOUCHER_INTIIAL_STATE]: {
      ...getButtonConfig(
        'Success',
        'voucher_top_up_confirm_code_cta',
        onConfirmCode,
        confirmCodeBtnID,
        '',
        !isValidVoucherTopupNumber,
      ),
      isVoucherTopUp,
      voucherBtnContainerStyle,
      successBtnDisabledStyle,
      successBtnDisabledTextStyle,
    },
    [VOUCHER_SCAN_QR_STATE]: {
      ...getButtonConfig(
        'Success',
        'voucher_topup_cancel_scan_code',
        onCancelQRCodeScan,
        cancelQRScan,
        null,
        false,
      ),
      btnSuccessType: voucherTopupQrScannerBtnType,
      btnsContainerStyle: voucherTopupQrScannerFooterBtnContainerStyle,
      btnSuccessStyle: voucherTopupQrScannerFooterBtnStyle,
    },
    [VOUCHER_TOP_UP_SUCCESS]: {
      ...getButtonConfig(
        'Success',
        'voucher_top_up_footer_button',
        closeModal,
        closeBtnID,
        '',
        false,
      ),
      btnSuccessType: 'secondary',
      btnSuccessStyle,
    },

    [VOUCHER_TOP_UP_ERROR]: {
      isVoucherTopUp,
      hasMoreBtns: isTwoBtnVoucherError,
      ...getButtonConfig(
        isTwoBtnVoucherError ? 'Reject' : 'Success',
        'voucher_top_up_footer_button',
        closeModal,
        closeBtnID,
        '',
        false,
      ),
      ...getButtonConfig(
        !isTwoBtnVoucherError ? 'Reject' : 'Success',
        'voucher_top_up_error_screen_footer_button',
        onRetryAgainPress,
        reTryAgainBtnID,
        '',
        false,
      ),
      btnSuccessType: isTwoBtnVoucherError ? 'primary' : 'secondary',
      btnRejectType: !isTwoBtnVoucherError ? 'primary' : 'secondary',
      btnSuccessStyle: isTwoBtnVoucherError ? null : btnSuccessStyle,
    },
  };
};

export default memoize(getPaymentFooterConfig);
